<template>
  <div>
    <my-head></my-head>
    <div class="newslist minH margin-auto">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">开放许可</span>
      </div>

      <div class="title">开放许可</div>

      <div class="title1">最新开放许可</div>

      <!-- 搜索框 -->
      <div class="flex-left-center sou_suo">
        <input type="text" v-model="ssInput" placeholder="请输入项目名称">
        <img src="../../assets/search.png" alt="" @click="souSuo">
        <div class="ss_but flex-center" @click="souSuo">搜索</div>
      </div>

      <div class="col flex-between-left" v-for="(item, index) in newslist" :key="index" @click="toNewsD(item.id)">
        <div :style="`width: ${item.imageUrl ? '82%' : '100%'}`">
          <div class="col_title line">
            {{ item.title }}
          </div>

          <div class="col_time" v-show="item.createTime">
            {{ item.createTime | dateYMD }}
          </div>

          <div class="col_content line-five" v-html="item.content"></div>
        </div>
        <img :src="item.imageUrl" alt="" />
      </div>

      <!-- 分页 -->
      <div class="flex-center fen_ye">
        <el-pagination background :current-page.sync="nespage.page" :page-size="nespage.size"
          layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      //分页数据
      nespage: {
        page: 1,
        size: 10,
      },
      total: 0, //开发总条数
      newslist: [], //开发列表数据
      ssInput: '',
    };
  },
  watch: {
    nespage: {
      handler() {
        this.newsList();
      },
      deep: true,
    },
  },
  methods: {
    // 搜索
    souSuo() {
      this.nespage.page = 1
      this.newsList()
    },
    // 开发列表接口
    newsList() {
      let data = {
        page: this.nespage.page - 1,
        size: this.nespage.size,
        category: 2,
        search: this.ssInput,
      };
      getRequest({ url: "/api/v1/markRelease/newsPage", data }).then((res) => {
        if (res.errcode == 200) {
          this.newslist = res.data;
          this.total = res.totalCount;
        }
      });
    },
    // 跳转开发详情
    toNewsD(id) {
      this.$router.push("/open?id=" + id);
    },
  },
  created() {
    this.newsList();
  },
};
</script>

<style lang="scss">
.newslist {
  width: 80%;
  padding-bottom: 48px;

  .sou_suo {
    margin-bottom: 20px;
    position: relative;

    .ss_but {
      height: 30px;
      color: #ffffff;
      background: #409EFF;
      padding: 0 12px;
      margin-left: 12px;
      border-radius: 2px;
      cursor: pointer;
    }

    img {
      height: 24px;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -12px;
      cursor: pointer;
    }

    input {
      border: none;
      background: #eeeeee;
      height: 30px;
      border-radius: 15px;
      outline: none;
      padding: 0 24px 0 34px;
      width: 600px;
    }


    // button {
    //   border: #cccccc solid 2px;
    //   padding: 0 12px;
    //   border-left: none;
    // }
  }

  .fen_ye {
    margin-top: 48px;
  }

  .col {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    margin-bottom: 24px;

    .col_time {
      font-size: 12px;
      margin-bottom: 8px;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
    }

    .col_title {
      font-size: 20px;
      margin: 0 0 8px;
      font-weight: bold;
      color: #1d2129;
      line-height: 28px;
    }

    img {
      width: 14.18%;
    }
  }

  .title1 {
    font-size: 14px;
    margin-bottom: 36px;
    font-weight: 400;
    color: #86909c;
    line-height: 22px;
  }

  .title {
    font-size: 30px;
    margin-bottom: 4px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
